import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
export default function SEO({ title = "The Only AI That Creates Content in YOUR Brand Voice | Sounds Real", description = "Tired of AI content that screams 'AI wrote this'? Our AI understands your brand's unique tone, style, and personality to generate content that sounds human. Start a Free Trial to see why marketing professionals choose us over generic AI tools.", keywords = "brand voice ai, ai content creator, brand voice content creation, ai content that doesn't sound robotic, marketing agency ai tools, brand voice generator, personal branding ai, social media content creator, ai content creation marketing agencies, brand voice ai platform, content creation brand voice, ai brand voice consistency, marketing content ai tools, brand voice content generator, human-like ai content", image = "https://multiwise.ai/og-image.jpg", url = "https://multiwise.ai", type = "website" }) {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Multiwise",
        "description": "Brand Voice AI Content Creation Platform - Create content that sounds human, not robotic",
        "url": url,
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "priceValidUntil": "2025-12-31",
            "availability": "https://schema.org/InStock"
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "ratingCount": "127",
            "bestRating": "5",
            "worstRating": "1"
        },
        "creator": {
            "@type": "Organization",
            "name": "Multiwise",
            "url": "https://multiwise.ai"
        },
        "featureList": [
            "Brand Voice AI Content Creation",
            "Human-Like Content Generation",
            "Marketing Agency Tools",
            "Social Media Content Creator",
            "Brand Voice Consistency",
            "Anti-Robotic AI Content"
        ]
    };
    return (_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "title", content: title }), _jsx("meta", { name: "description", content: description }), _jsx("meta", { name: "keywords", content: keywords }), _jsx("meta", { name: "robots", content: "index, follow" }), _jsx("meta", { name: "language", content: "English" }), _jsx("meta", { name: "author", content: "Multiwise" }), _jsx("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" }), _jsx("meta", { property: "og:type", content: type }), _jsx("meta", { property: "og:url", content: url }), _jsx("meta", { property: "og:title", content: title }), _jsx("meta", { property: "og:description", content: description }), _jsx("meta", { property: "og:image", content: image }), _jsx("meta", { property: "og:image:width", content: "1200" }), _jsx("meta", { property: "og:image:height", content: "630" }), _jsx("meta", { property: "og:site_name", content: "Multiwise" }), _jsx("meta", { property: "twitter:card", content: "summary_large_image" }), _jsx("meta", { property: "twitter:url", content: url }), _jsx("meta", { property: "twitter:title", content: title }), _jsx("meta", { property: "twitter:description", content: description }), _jsx("meta", { property: "twitter:image", content: image }), _jsx("meta", { property: "twitter:creator", content: "@multiwise" }), _jsx("meta", { name: "theme-color", content: "#7C3AED" }), _jsx("meta", { name: "msapplication-TileColor", content: "#7C3AED" }), _jsx("meta", { name: "apple-mobile-web-app-capable", content: "yes" }), _jsx("meta", { name: "apple-mobile-web-app-status-bar-style", content: "default" }), _jsx("meta", { name: "apple-mobile-web-app-title", content: "Multiwise" }), _jsx("link", { rel: "canonical", href: url }), _jsx("script", { type: "application/ld+json", children: JSON.stringify(structuredData) }), _jsx("script", { type: "application/ld+json", children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Multiwise",
                    "url": "https://multiwise.ai",
                    "logo": "https://multiwise.ai/logo.png",
                    "description": "Brand Voice AI Content Creation Platform - The only AI that creates content in your brand voice",
                    "foundingDate": "2024",
                    "sameAs": [
                        "https://twitter.com/multiwise",
                        "https://linkedin.com/company/multiwise"
                    ],
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+1-555-MULTIWISE",
                        "contactType": "customer service",
                        "email": "support@multiwise.ai"
                    }
                }) }), _jsx("script", { type: "application/ld+json", children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                        {
                            "@type": "Question",
                            "name": "What is brand voice AI content creation?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Brand voice AI content creation uses artificial intelligence to generate content that matches your brand's unique tone, style, and personality. Unlike generic AI tools, Multiwise learns your specific brand voice to create content that sounds human and authentic."
                            }
                        },
                        {
                            "@type": "Question",
                            "name": "Why does AI content sound robotic?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Most AI tools create generic content without understanding brand voice or personality. They use one-size-fits-all approaches that result in robotic, impersonal content that screams 'AI wrote this.' Multiwise solves this by learning your unique brand voice."
                            }
                        },
                        {
                            "@type": "Question",
                            "name": "How can marketing agencies maintain brand voice consistency?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Marketing agencies can use brand voice AI tools like Multiwise to maintain consistent client brand voices across all content. Our platform learns each client's unique voice and ensures every piece of content matches their brand personality."
                            }
                        },
                        {
                            "@type": "Question",
                            "name": "Is Multiwise free for marketing agencies?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Yes, Multiwise offers a free trial for marketing agencies to test our brand voice AI content creation. We also offer agency-specific plans designed for managing multiple client brand voices efficiently."
                            }
                        }
                    ]
                }) })] }));
}
